import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './NewCustomPages.module.scss';
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";
import { WallPaintModification } from './NewCustomPagesConstants';
import CivilWorkOptions from "../CivilWorkServices/CivilWorkOptions";

const WallPainting = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  return (
    <section className={style.new_page_container}>
      <h2 className="section_heading">Painting Services</h2>
      <div className={style.wall_electrical_container}>
        <div className={`${style.canvas_container} ${style.two_col_tab}`}>
          <section>
            <div>
              <p>Key Plan of the House / Site Photograph of the Room</p>
            </div>
          </section>
          <section>
            {
              updatedValues?.planImageUrl ? <img crossOrigin="anonymous" src={`${updatedValues?.planImageUrl}?ver=${new Date().getTime()}`} alt="" className="image-view" /> :
                <div>
                  <p>Floor Plan with Wall Tagging (Wall Orientation)</p>
                </div>
            }
          </section>
        </div>
        <div className={style.wall_electrical_modification}>
          <h2 className="sub_tab_heading">PAINTING DETAILS</h2>
          <div className={style.summary_table}>
            <div className={`${style.six_col_tab}`}>
              <h4>Wall Tagging</h4>
              <h4>Service Type</h4>
              <h4>Product Name</h4>
              <h4>Brand</h4>
              <h4>Color Code</h4>
              <h4>Quantity (sq.ft)</h4>
            </div>
            {
              updatedValues?.wallDetails ? updatedValues?.wallDetails?.map((e, id) => (
                <div key={id} className={`${style.six_col_tab}`}>
                  <p>{e?.wallTagging || '-'}</p>
                  <p>{e?.subCategory || '-'}</p>
                  <p>{e?.productName || '-'}</p>
                  <p>{e?.brand || '-'}</p>
                  <p>{e?.colorCode || '-'}</p>
                  <p>{e?.qty?.toFixed(2) || '-'}</p>
                </div>
              )) : <div className={`${style.six_col_tab}`}>{
                WallPaintModification?.map((e, i) => (
                  <p><CivilWorkOptions details={e} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} type={"input"} /></p>
                ))
              }
              </div>
            }
          </div>
        </div>
      </div>
    </section>
  )
}

export default WallPainting;